<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState([
      'pages'
    ]),
    pageList () {
      return Object.keys(this.pages).map(key => this.pages[key])
    }
  },
  created () {
    this.fetchPages()
  },
  methods: {
    ...mapActions([
      'fetchPages'
    ])
  }
}
</script>

<template>
  <div class="home level-left is-mobile">
    <section class="page-list">
      <header>
        <h1 class="is-size-3">
          <router-link
            :to="{name: 'home'}"
          >/</router-link>
        </h1>
      </header>
      <ul>
        <li v-for="page in pageList" :key="page.id">
          <router-link :to="{name: 'page', params: {pageId: page.id}}">
            <span class="link">{{ page.title }}</span>
          </router-link>
        </li>
      </ul>
    </section>
    <div class="route-transition">
      <router-view v-slot="{ Component }">
        <transition name="slide">
          <component
            :is="Component"
            :key="$route.params.pageId"
          />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
.home {
  align-items: flex-start;
  height: 100%;
  section {
    max-height: 100%;
    width: variables.$width-page-list;
    overflow: scroll;
  }
  .route-transition {
    width: calc(100vw - #{variables.$width-page-list});
  }
}
</style>
